export const STEP_TYPE = {
  CUSTOMER_INFO: 'customer_info',
  CONFIRMATION: 'confirmation',
  PAYMENT: 'payment',
  SUBSCRIPTION_TYPE: 'customer_subscription_type',
  CUSTOMER_INFO_CONFIRMATION: 'customer_info_confirmation'
}
